package one.devsbox.www.ui.uploader

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import one.devsbox.www.io.Repository
import one.devsbox.www.tools.FilePicker
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.getString
import org.w3c.files.File
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class UploaderVM : NavigationViewModel() {
    private lateinit var ctx: UploaderCtx

    var state by mutableStateOf<DataState<Unit>>(DataState.Idle())
        private set

    var uploadProgress by mutableStateOf<Int?>(null)
        private set
    var uploadStatus by mutableStateOf<StringResource?>(null)
        private set

    interface Action {
        fun pickAndUploadImage()
        fun pickAndUploadVideo()
        fun pickAndUploadPdf()
        fun tryAgain()
        fun back()
    }

    val action = object : Action {
        override fun pickAndUploadImage() {
            scope.launch {
                val file = FilePicker.pickFile(
                    listOf(
                        "image/jpeg",
                        "image/png",
                        "image/webp",
                        "image/gif"
                    )
                )
                if (file != null) {
                    performUpload(file, Repository.buildUploadUrlIMAGE())
                }
            }
        }

        override fun pickAndUploadVideo() {
            scope.launch {
                val file = FilePicker.pickFile(
                    listOf(
                        "video/mp4",
                        "video/webm",
                        "video/ogg",
                        "video/quicktime"
                    )
                )
                if (file != null) {
                    performUpload(file, Repository.buildUploadUrlVIDEO())
                }
            }
        }

        override fun pickAndUploadPdf() {
            scope.launch {
                val file = FilePicker.pickFile(
                    listOf(
                        "application/pdf"
                    )
                )
                if (file != null) {
                    performUpload(file, Repository.buildUploadUrlPDF())
                }
            }
        }

        override fun tryAgain() {
            if (state is DataState.Result || state is DataState.Error) {
                uploadProgress = null
                uploadStatus = null
                state = DataState.Idle()
            }
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: UploaderCtx) {
        this.ctx = ctx
        action.tryAgain()
    }

    private fun performUpload(file: File, url: String) {
        scope.launch {
            uploadProgress = 0
            uploadStatus = Res.string.ui_uploader_status_init
            state = DataState.Loading()

            val success = FilePicker.uploadFile(
                file = file,
                uploadUrl = url,
                token = Repository.ads.token
            ) { percent ->
                uploadProgress = percent
                uploadStatus =
                    if (percent < 100) Res.string.ui_uploader_status_uploading else Res.string.ui_uploader_status_processing
            }

            uploadProgress = null
            uploadStatus = null

            if (success) {
                state = DataState.Result(Unit)
                ctx.nav.up()
            } else {
                val errMsg = getString(Res.string.ui_uploader_error_prefix, file.name)
                state = DataState.Error(errMsg)
            }
        }
    }

    override fun onRelease() {}
}
